/* global axios */
import ApiClient from './ApiClient';

/**
 * Teletel audit trail API client.
 *
 * Extends Chatwoot's ApiClient purely to reuse its account-from-route logic, then
 * prefixes /teletel so the request never collides with a Chatwoot endpoint.
 * Read-only: there is deliberately no create/update/delete here, matching the
 * append-only server model.
 */
class TeletelAuditEventsAPI extends ApiClient {
  constructor() {
    super('audit-events', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new TeletelAuditEventsAPI();
